<template>
  <q-page padding class="column items-center q-gutter-md">
    <div class="col-1 full-width">
      <h5 class="q-ma-sm">Участники</h5>
    </div>
    <div class="col-1 full-width">
      <q-form class="row q-gutter-sm justify-center" @submit.prevent="updatePermission(email, 'READ')">
        <div class="col-10">
          <q-input v-model="email" filled dense :rules="[emailRule, requiredRule]" />
        </div>
        <div class="col-1 ">
          <q-btn color="primary" label="Добавить" type="submit" />
        </div>
      </q-form>
    </div>
    <div class="col-10 full-width">
      <q-list>
        <q-item v-if="!isFetching" v-for="permission in permissions" :key="permission.user.email">
          <q-item-section avatar>
            <q-avatar color="primary" text-color="white" v-if="permission.user.active">
              {{ permission.user.username[0].toUpperCase() }}
            </q-avatar>
            <q-avatar v-else>
              {{ permission.user.email[0].toUpperCase() }}
            </q-avatar>
          </q-item-section>

          <q-item-section v-if="permission.user.active">
            <q-item-label>{{ permission.user.username }}</q-item-label>
            <q-item-label caption lines="1">{{ permission.user.email }}</q-item-label>
            <q-item-label caption lines="1">{{ roles[permission.permission] }}</q-item-label>
          </q-item-section>

          <q-item-section v-else>
            <q-item-label> Не зарегистрирован</q-item-label>
            <q-item-label caption lines="1">{{ permission.user.email }}</q-item-label>
            <q-item-label caption lines="1">{{ roles[permission.permission] }}</q-item-label>
          </q-item-section>

          <q-item-section side>
            <q-select dense :model-value="permission.permission" :options="rolesOptions" emit-value map-options clearable
              :disable="(permission.user.email === organization?.owner.email || permission.user.email === user.email)"
              @update:model-value="v => updatePermission(permission.user.email, v)" />
          </q-item-section>
        </q-item>
      </q-list>
    </div>
  </q-page>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";
import { computed, ref } from "vue";
import { rolesOptions, roles } from "../util/roles";
import { requiredRule, emailRule } from "../util/rules";
import { Permission, UpdateProjectPermission } from "../models/project";
import { useOrganization, useOrganizationUsers, useUpdateOrganizationUsers } from "../composables/organization";
import { useRouteParams } from "@vueuse/router";
import { useQuasar } from "quasar";
import { useUserStore } from "../store/user";
import { storeToRefs } from "pinia";

const route = useRoute()

const email = ref("")
const organizationId = useRouteParams('organizationId', undefined, { transform: Number })
const { isFetching, data: permissions, execute } = useOrganizationUsers(organizationId)
const $q = useQuasar()
const { data: organization, isFetching: loading } = useOrganization(organizationId)
const userStore = useUserStore()
const { user } = storeToRefs(userStore)

async function updatePermission(email: string, permission: Permission) {
  if (!permission) {
    $q.dialog({
      title: 'Удаление пользователя',
      message: 'Вы уверены что хотите удалить пользователя из проекта?',
      cancel: true,
      persistent: true
    }).onOk(async () => {
      const request: UpdateProjectPermission = {
        email: email,
        permission: permission
      }
      await useUpdateOrganizationUsers(organizationId, request)
      await execute()
    })
  } else {
    const request: UpdateProjectPermission = {
      email: email,
      permission: permission
    }
    await useUpdateOrganizationUsers(organizationId, request)
    await execute()
  }

}
</script>

<style scoped></style>